import React from "react";
import Footer from "./Footer";

function AddNew() {
  return (
    <>
      <div className="container-fluid mt-60px pb-5 mb-5">
        <div className="threshold-box p-3 mt-3">
          <h5 className="mb-3 mt-3">Add New</h5>

          <form>
            {/* --- Top Row: 5 selectors --- */}
            <div
              className="d-flex flex-wrap gap-3"
              style={{ justifyContent: "space-between" }}
            >
              {/* Country with vertical dropdowns below */}
              <div style={{ flex: "1 1 18%", display: "flex", flexDirection: "column" }}>
                <label className="form-label fw-semibold  mt-2">Country</label>
                <select className="form-select mb-2">
                  <option value="">Select Country</option>
                  <option value="malawi">Malawi</option>
                  <option value="zambia">Zambia</option>
                  <option value="tanzania">Tanzania</option>
                </select>

                {/* 4 dropdowns below Country */}
                <label className="form-label fw-semibold mt-2">Min Air Temperature</label>
                <select className="form-select mb-2">
                  <option value="">Min Air Temperature</option>
                </select>

                <label className="form-label fw-semibold mt-2">Max Air Temperature</label>
                <select className="form-select mb-2">
                  <option value="">Max Air Temperature</option>
                </select>

                {/* <label className="form-label fw-semibold mt-2">Pond Temperature</label>
                <select className="form-select mb-2">
                  <option value="">Pond Temperature</option>
                </select> */}

                <label className="form-label fw-semibold mt-2">Max Pond Temp</label>
                <select className="form-select mb-2">
                  <option value="">Max Pond Temp</option>
                </select>

                <label className="form-label fw-semibold mt-2">Min Pond Temp</label>
                <select className="form-select mb-2">
                  <option value="">Min Pond Temp</option>
                </select>
              </div>

              {/* Other 4 dropdowns in the top row */}
              <div style={{ flex: "1 1 18%" }}>
                <label className="form-label fw-semibold">Region</label>
                <select className="form-select">
                  <option value="">Select Region</option>
                  <option value="north">Northern</option>
                  <option value="south">Southern</option>
                  <option value="east">Eastern</option>
                </select>
              </div>

              <div style={{ flex: "1 1 18%" }}>
                <label className="form-label fw-semibold">District</label>
                <select className="form-select">
                  <option value="">Select District</option>
                  <option value="lilongwe">Lilongwe</option>
                  <option value="blantyre">Blantyre</option>
                  <option value="mzuzu">Mzuzu</option>
                </select>
              </div>

              <div style={{ flex: "1 1 18%" }}>
                <label className="form-label fw-semibold">Camp</label>
                <select className="form-select">
                  <option value="">Select Camp</option>
                  <option value="camp1">Camp 1</option>
                  <option value="camp2">Camp 2</option>
                  <option value="camp3">Camp 3</option>
                </select>
              </div>

              <div style={{ flex: "1 1 18%" }}>
                <label className="form-label fw-semibold">Species</label>
                <select className="form-select">
                  <option value="">Select Species</option>
                  <option value="tilapia">Tilapia</option>
                  <option value="catfish">Catfish</option>
                  <option value="carp">Carp</option>
                </select>
              </div>
            </div>
          </form>
        </div>
        <div className="d-flex justify-content-end align-items-center">
        <button className="btn btn-cancel1">Cancel</button>
         <button className="btn btn-save1 ms-3">Save</button>
      </div>
      </div>

      <Footer />
    </>
  );
}

export default AddNew;
